import { MenuItemLink } from 'layouts/components/Menu/components/MenuItemLink/MenuItemLink';
import { MenuItemLinkWithCounter } from 'layouts/components/Menu/components/MenuItemLinkWithCounter/MenuItemLinkWithCounter';
import { MultiLevelMenuItem } from 'layouts/components/Menu/constants/menuList';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Typography } from 'shared/mui/Typography';

import { StyledBox } from './MenuSubMenuPanel.styled';

type Props = {
  selectedResourceMenuItem: MultiLevelMenuItem;
  setCurrentResourceMenuItem: (resource: string | null) => void;
};

export const MenuSubMenuPanel: React.FC<Props> = ({
  selectedResourceMenuItem: { title, items },
  setCurrentResourceMenuItem,
}) => {
  const translate = useTypedTranslate();

  return (
    <StyledBox>
      <Typography fontSize="14px" mb={2} ml={3} mt={2}>
        {translate(title)}
      </Typography>
      {items.map(({ resource, title, counter }) => {
        const props = {
          className: 'RaMenuItemLink__submenu',
          onClick: () => setCurrentResourceMenuItem(null),
          primaryText: translate(title),
          resource,
          to: `/${resource}`,
          tooltipProps: {
            title: false,
            children: <></>,
          },
        };

        if (counter) {
          return <MenuItemLinkWithCounter counter={counter} key={title} {...props} />;
        }
        return <MenuItemLink key={title} {...props} />;
      })}
    </StyledBox>
  );
};
